export default class formConfig {
  // 企业登记信息-详情
  static configList() {
    return [
      {
        title: "招标计划",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标计划是否发布：",
            type: "select",
            value: "isReleasePlannedTender",
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202203150950310935",
            },
          },
          {
            label: "是否限制公告发布：",
            type: "select",
            value: "isRestrictAnnouncement",
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202203150950230934",
            },
          },
          {
            label: "计划招标时间：",
            value: "plannedTenderTime",
            type: "input",
            disabled: true,
          },
        ]
      },
      {
        title: "招标机构组织人员",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "organizationList",
            class: "formList"
          },
        ]
      },
      {
        title: "项目计划工作任务",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "工作任务计划：",
            value: "taskPlan",
            type: "textarea",
            width: "100%;",
            disabled: true
          }
        ]
      },
      {
        title: "房屋建筑单体工程明细",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "buildingMonomerList",
            class: "formList"
          }, 
        ]
      },
      {
        title: "市政基础设施工程明细",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "municipalList",
            class: "formList"
          }, 
        ]
      },
      {
        title: "材料设备采购明细",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "equipmentList",
            class: "formList"
          }, 
        ]
      },
    ];
  }
}
